import { alpha as r } from "./atoms-v21098.js";
import { px as e } from "./atoms-v2960.js";
import { browserNumberValueTypes as m } from "./atoms-v21099.js";
import { transformValueTypes as p } from "./atoms-v21100.js";
import { int as o } from "./atoms-v21101.js";
const l = {
  ...m,
  ...p,
  zIndex: o,
  size: e,
  // SVG
  fillOpacity: r,
  strokeOpacity: r,
  numOctaves: o
};
export {
  l as numberValueTypes
};
